import React, { Component } from "react";
import PropTypes from "prop-types";
import Formsy from "formsy-react";
import { isObject, orderBy, find } from "lodash";

import { Input } from "formsy-react-components";
import { Row, Col } from "react-bootstrap";

import DropdownSearch from "../../common/DropdownSearch";
import PhoneNumberInput from "../../common/PhoneNumberInput";

class ContactForm extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      canSubmit: false
    };
  }

  onChange = (field, selected) => {
    this.setState({ [field]: selected.value });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  add = (model) => {
    this.props.onAdd(model);
  };

  submit = (model) => {
    model.id = this.props.contact._id;
    this.props.onSave(model);
  };

  cancel = () => {
    this.props.onCancel();
  };

  generateLocationOptions = () => {
    const { customer, codes } = this.props;
    const locationOptions = customer.locations.map((location) => {
      let state = isObject(location.address.state)
        ? location.address.state._id
        : location.address.state;
      state = find(codes, { _id: state });
      return {
        value: location._id,
        label: `${location.name} (${location.address.addr1} - ${location.address.city}, ${state.value})`
      };
    });

    return locationOptions;
  };

  generateCodeOptions = (entity, field) => {
    const codeOptions = this.props.codes
      .filter((codes) => codes.entity === entity && codes.field === field)
      .map((code) => ({
        value: code._id,
        label: code.label
      }));

    return orderBy(codeOptions, "label");
  };

  render() {
    const { contact, adding, saving } = this.props;

    if (adding) {
      contact.address = contact.address || {};
    }

    return (
      <Formsy
        ref={(ref) => (this.form = ref)}
        className="vertical form"
        onValidSubmit={adding ? this.add : this.submit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
      >
        <Row>
          <Col md={3} xs={12}>
            <Input
              required
              name="first_name"
              label="First Name"
              placeholder="First Name"
              value={contact.first_name}
              validations={{ maxLength: 50 }}
              validationErrors={{
                maxLength: "You can not type in more than 50 characters"
              }}
            />
          </Col>
          <Col md={3} xs={12}>
            <Input
              required
              name="last_name"
              label="Last Name"
              placeholder="Last Name"
              value={contact.last_name}
              validations={{ maxLength: 50 }}
              validationErrors={{
                maxLength: "You can not type in more than 50 characters"
              }}
            />
          </Col>
          <Col md={6} xs={12}>
            <DropdownSearch
              name="location"
              label="Location"
              onChange={this.onChange}
              value={this.state.location || contact.location}
              data={[...this.generateLocationOptions()]}
            />
          </Col>
        </Row>
        <Row>
          <Col md={3} xs={12}>
            <Input
              name="title"
              label="Title"
              placeholder="Title"
              value={contact.title}
              validations={{ maxLength: 50 }}
              validationErrors={{
                maxLength: "You can not type in more than 50 characters"
              }}
            />
          </Col>
          <Col md={3} xs={12}>
            <DropdownSearch
              required
              name="role"
              label="Role"
              onChange={this.onChange}
              value={this.state.role || contact.role}
              data={[...this.generateCodeOptions("Contact", "role")]}
            />
          </Col>
          <Col md={3} xs={12}>
            <Input
              required
              name="email"
              label="Email"
              placeholder="Email"
              value={contact.email}
              validations={{ maxLength: 50 }}
              validationErrors={{
                maxLength: "You can not type in more than 50 characters"
              }}
            />
          </Col>
          <Col md={3} xs={12}>
            <PhoneNumberInput
              name="mobile_phone"
              label="Mobile Phone"
              placeholder="Mobile Phone"
              value={contact.mobile_phone}
            />
          </Col>
          <Col md={3} xs={12}>
            <PhoneNumberInput
              name="fax"
              label="Fax"
              placeholder="Fax"
              value={contact.fax}
            />
          </Col>
          <Col md={3} xs={10}>
            <PhoneNumberInput
              name="business_phone"
              label="Business Phone"
              placeholder="Business Phone"
              value={contact.business_phone}
            />
          </Col>
          <Col md={1} xs={2}>
            <Input
              name="business_phone_ext"
              label="Ext."
              placeholder="Ext."
              value={contact.business_phone_ext}
              validations={{ maxLength: 50 }}
              validationErrors={{
                maxLength: "You can not type in more than 50 characters"
              }}
            />
          </Col>
          <Col md={12} xs={12} className="footer">
            <button
              className="btn btn-outline btn-cancel"
              type="button"
              onClick={this.cancel}
            >
              CANCEL
            </button>
            <input
              className="btn btn-success"
              type="submit"
              disabled={
                !this.state.canSubmit || saving || this.props.savingCustomer
              }
              value={
                saving || this.props.savingCustomer ? "Saving... " : "Save"
              }
            />
          </Col>
        </Row>
      </Formsy>
    );
  }
}

ContactForm.propTypes = {
  customer: PropTypes.object.isRequired,
  contact: PropTypes.object.isRequired,
  codes: PropTypes.array,
  adding: PropTypes.bool,
  saving: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  savingCustomer: PropTypes.bool
};

export default ContactForm;
